import styles from './DataCards.module.scss'

const DataCards = ({ data }) => (
  
<div className={styles.statscontainer}>
      {data.map((item, index) => (
        <div className={styles.statcard} key={index}>
          <p className={styles.statlabel}>{item.label}</p>
          <p className={styles.statvalue}>{Number(item.value).toLocaleString('en-US')}</p>
        </div>
      ))}
    </div>

)

export default DataCards